import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import config from "config";

const options = {
  debug: false,

  interpolation: {
    escapeValue: false,
  },
  saveMissing: false,

  backend: {
    addPath: `${config.API_ROOT}/main/translations/{{lng}}/main.json`,
  },
};

export default () => {
  i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init(options);

  return i18n;
};
